export const config = {
  api_url: process.env.VUE_APP_API_URL,
  client_url: process.env.VUE_APP_CLIENT_URL,
  token_key: "web-auth",
  ecal_api_key:"1wWVn3eLXd6Z3lSQNcCSHyma98IJGJPbojhwkOM9pU64021d95",
  widget_id:"640a4d3e454273000d8a87d4"
};
